import script from "./ServiceStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceStatus.vue?vue&type=script&setup=true&lang=js"

import "./ServiceStatus.vue?vue&type=style&index=0&id=a8284588&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8284588"]])

export default __exports__